module.exports = __webpack_public_path__ + "img/img1.add37768.png";